import { css, cva } from "../../../styled-system/css";

const initialStyles = {
  fontWeight: 800,
  flexShrink: 0,
  alignItems: "center",
  justifyContent: "center",
  gap: "baseUnit.mobile1",
  pointerEvents: "initial",
  cursor: "pointer",
  textDecoration: "underline",
  textUnderlinePosition: "under",
};

export const baseButtonStyles = css({
  ...initialStyles,
  minHeight: "42px",
  display: "inline-flex",
  fontSize: "body.shrimp",
  lineHeight: "body.shrimp",
  letterSpacing: "body.butterfly",
  paddingX: "baseUnit.mobile3",
  paddingY: "baseUnit.mobile1",
  borderRadius: "8px",
  transition: "background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, text-decoration-color 0.2s ease",
  _disabled: {
    pointerEvents: "none",
    cursor: "default",
    textDecoration: "none",
  },
  _focus: {
    outlineColor: "oceanBlue",
  },
  _focusVisible: {
    outline: "2px solid",
    outlineOffset: "2px",
  },
  "& svg": {
    width: "100%",
    height: "100%",
    "& path": {
      transition: "fill 0.2s ease",
    },
  },
});

export const linkStyles = css({
  ...initialStyles,
  color: "skyBlue",
  fontSize: "body.mouse",
  letterSpacing: "body.mouse",
  lineHeight: "body.mouse",
  textDecorationColor: "skyBlue",
  textDecorationStyle: "dotted",
  textDecorationThickness: "13%",
  borderRadius: "4px",
  transition: "color 0.2s ease, text-decoration-color 0.2s ease",
  _hover: {
    textDecorationStyle: "solid",
    color: "oceanBlue",
    textDecorationColor: "oceanBlue",
  },
  _focus: {
    outlineColor: "oceanBlue",
  },
  _focusVisible: {
    color: "oceanBlue",
    outline: "1px solid",
    outlineColor: "oceanBlue",
    outlineOffset: 0,
    textDecoration: "none",
  },
  _disabled: {
    color: "lightGrey",
  },
  "& svg": {
    width: "100%",
    height: "100%",
    "& path": {
      transition: "fill 0.2s ease",
    },
  },
});

export const buttonRecipe = cva({
  variants: {
    variant: {
      standard: {
        color: "white",
        backgroundColor: "skyBlue",
        textDecorationColor: "transparent",

        "& svg path": {
          fill: "white",
        },

        _hover: {
          backgroundColor: "oceanBlue",
          textDecorationColor: "white",
        },

        _active: {
          backgroundColor: "abyssBlue",
        },

        _disabled: {
          backgroundColor: "lightGrey",
          color: "white",
        },
      },
      outlined: {
        color: "black",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "black",
        textDecorationColor: "transparent",

        "& svg path": {
          fill: "black",
        },

        _hover: {
          color: "oceanBlue",
          borderColor: "oceanBlue",
          textDecorationColor: "oceanBlue",
          "& svg path": {
            fill: "oceanBlue",
          },
        },

        _active: {
          background: "blueTintDark",
        },

        _disabled: {
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "lightGrey",
          color: "lightGrey",
          "& svg path": {
            fill: "lightGrey",
          },
        },
      },
      outlinedInverted: {
        color: "white",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "white",
        textDecorationColor: "transparent",

        _hover: {
          background: "backgroundGrey",
          color: "blue",
          textDecorationColor: "blue",
        },

        _focus: {
          background: "paleBlueLight",
          color: "blue",
          textDecorationColor: "blue",
        },

        _active: {
          background: "paleBlueLight",
        },

        _disabled: {
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "lightGrey",
          color: "lightGrey",
        },
      },
      danger: {
        color: "white",
        backgroundColor: "crimsonRed",
        textDecorationColor: "transparent",

        "& svg path": {
          fill: "white",
        },

        _hover: {
          backgroundColor: "cardinalRed",
          textDecorationColor: "white",
        },

        _active: {
          backgroundColor: "oxbloodRed",
        },

        _disabled: {
          backgroundColor: "lightGrey",
          color: "white",
        },
      },
      dangerOutlined: {
        color: "crimsonRed",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "crimsonRed",
        textDecorationColor: "transparent",

        "& svg path": {
          fill: "crimsonRed",
        },

        _hover: {
          color: "cardinalRed",
          borderColor: "cardinalRed",
          textDecorationColor: "cardinalRed",
          "& svg path": {
            fill: "cardinalRed",
          },
        },

        _active: {
          background: "redTint",
        },

        _disabled: {
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "lightGrey",
          color: "lightGrey",
          "& svg path": {
            fill: "lightGrey",
          },
        },
      },
      textDecorated: {
        color: "linkBlue",
        textDecorationColor: "linkBlue",

        _hover: {
          background: "backgroundGrey",
          textDecorationColor: "linkBlue",
        },

        _focusVisible: {
          background: "paleBlueLight",
        },

        _active: {
          background: "paleBlueLight",
        },

        _disabled: {
          color: "lightGrey",
        },
      },
    },
  },
});
